module.exports = __webpack_public_path__ + "media/asset/images/TokyoGAS/ITRI_company_top_TokyoGAS-744c4222c617ae1103bf07a5c6146596.png";